import { useApiMutation } from '@/api/hooks/useMutation';
import { ENV } from '@/config/env';

export function useInstagramConnect() {
  return useApiMutation({
    mutationFn: (api) => async () => {
      const response = await api.settings.settingsControllerGetAuthorizationUrl(
        'INSTAGRAM',
        ENV.instagram.redirectUri
      );
      const url = response.data.serviceAuthorizationUrl;
      if (!url) throw new Error('Failed to start Instagram connection');
      return { url };
    },
  });
}
